import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useCallback } from 'react';
export var FilterContext = /*#__PURE__*/React.createContext(null);
export var FilterContextProvider = function FilterContextProvider(_ref) {
  var children = _ref.children;

  var _React$useState = React.useState({}),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      filter = _React$useState2[0],
      setFilter = _React$useState2[1];

  var getFilter = useCallback(function (key) {
    return filter[key];
  }, [filter]);
  var setFilterItem = useCallback(function (key, newFilter) {
    setFilter(_objectSpread(_objectSpread({}, filter), {}, _defineProperty({}, key, newFilter)));
  }, [filter]);
  return /*#__PURE__*/React.createElement(FilterContext.Consumer, null, function (context) {
    return /*#__PURE__*/React.createElement(FilterContext.Provider, {
      value: context !== null && context !== void 0 ? context : {
        filter: filter,
        setFilter: setFilterItem,
        getFilter: getFilter
      }
    }, children);
  });
};